import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import image from '../../../assets/Image.svg'

export const ProfileCardContainer = styled.section`
    display: ${(props) => props.display};
    position: absolute;
    flex-direction:column;
    top: 107px;
    right: 291px;
    border-radius: 10px;
    background-color: #262626 ;
    width:320px;
    margin-top:30px;
    align-items:center;
    z-index: 10;

`
export const ProfileCardHead = styled.div`
    display:flex;
    border-radius: 50%;
    border-style: solid;
    border-color: #40a9ff;
    height:152px;
    width: 152px;
    margin-top: 44px;
`
export const ProfileImage = styled.img`

`
export const PorfileCaption = styled.div`
    color: #389e0d;
    line-height:15px;
    font-size:15px;
    margin-top:26px;
    text-align:center;
`
export const WalletAddress = styled.div`
    color: #8c8c8c;
    font-size:16px;
    line-height: 19px;
`
export const ChangePicture = styled.button`
    width:280px;
    margin: 20px 20px 0px 20px;
    padding: 14.5px 10px;
    color: white;
    background-color: black;
    border: none;
    border-radius: 10px;
    font-size:16px;
    line-height: 19px;
    

`
export const DisconnectWallet = styled.button`
    width:280px;
    margin: 8px 20px 20px 20px;
    padding: 14.5px 10px;
    color: white;
    background-color: black;
    border: none;
    border-radius: 10px;
    font-size:16px;
    line-height: 19px;


`

const ProfileCard = ({display}) => {
    const { t } = useTranslation()

  return (
    <>
    <ProfileCardContainer display={display}>
        <ProfileCardHead>
            <ProfileImage src={image}/>
        </ProfileCardHead>
        <PorfileCaption>
                <WalletAddress>Mpzi8uaA......yMv</WalletAddress>
                {t("page5.profileCard.connected")}
            </PorfileCaption>
        <ChangePicture>
            {t("page5.profileCard.changePicture")}
        </ChangePicture>
        <DisconnectWallet>
        {t("page5.profileCard.disconnect")}
        </DisconnectWallet>
    </ProfileCardContainer>
    </>
  )
}

export default ProfileCard